import { useContext, useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import ConfirmationPopup from "../../../shared/components/confirmation-popup/confirmation-popup";
import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { useHttpGet } from "../../../shared/hooks/use-httpNonTable";
import { getData, postSingle, succesfulToast } from "../../../shared/utils/api";
import { useBack } from "../../../shared/utils/use-back";
import { IObject, validateLoadingStatusNew } from "../../../shared/utils/utils";
import MultiTabComponent, { IMultiTabComponentConfig } from "../../components/multi-tab-component/multi-tab-component";
import { IWidgetLayout } from "../../components/widgets-layout/widget-component/widget-component";
import "./alertcase-new.scss";
import { usePrompt } from "../../../shared/utils/use-prompt";
import CreateNewEventRow from "./steps/create-new-event";
import AlertCaseSetup, { IAlertCaseSetupData as IAlertCaseSetupData } from "./steps/alertcase-setup";

const AlertCaseNew = () => {
  const navigate = useNavigate();
  
  const { handleBack } = useBack();
  const authCtx = useContext(AuthContext);

  const [layout, setLayout] = useState<IWidgetLayout | undefined>();
  const [eventId, setEventId] = useState<string>("");
  const [alertedEventData, setAlertedEventData] = useState<IObject>({});
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const { flag, setFlag, next } = usePrompt(isDirty);
  const [alertcaseScreenData, setAlertcaseScreenData] = useState<IAlertCaseSetupData>(
    {
      domain_id: "", 
      process_type_id: "",
      process_type_name: "",
      domain_name: "",
      consolidate_on_entity_id: "",
      event_capture_id: ""
    }
  );

  const {
    sendRequest: postConsolidateEventRowData,
    status: postConsolidateEventRowDataStatus,
    data: postConsolidateEventRowDataResult,
    error: postConsolidateEventRowDataError
  } = useHttp(
    postSingle,
    false,
    authCtx.token,
    "consolidateEvent",
    "manager"
  );
  const {
    sendRequest: getEventCapture,
    status: getEventCaptureStatus,
    data: eventCaptureData,
    error: getEventCaptureError
  } = useHttpGet(getData, false, authCtx.token, "capture", "manager");

  useEffect(() => {
    if (alertcaseScreenData.event_capture_id) {
      getEventCapture(`capture/${alertcaseScreenData.event_capture_id}`);
    }
  }, [alertcaseScreenData.event_capture_id]);

  useEffect(() => {
    if (getEventCaptureStatus === "completed" && eventCaptureData && !getEventCaptureError) {
      setLayout(eventCaptureData.layout);
      setEventId(eventCaptureData.datamodel_id);
    }
  }, [getEventCaptureStatus, eventCaptureData, getEventCaptureError]);
  
  useEffect(() => {
    if (postConsolidateEventRowDataResult && postConsolidateEventRowDataStatus === "completed" && !postConsolidateEventRowDataError) {
      succesfulToast(postConsolidateEventRowDataResult.msg);
      navigate("/manager/alertcases");
    }
  }, [postConsolidateEventRowDataResult]);

  useEffect(() => {
    setIsDirty(true);
  }, [alertcaseScreenData, alertedEventData]);

  const handleAddNewEvent = () => {
    if (postConsolidateEventRowDataStatus === "pending") {
      return;
    }
    postConsolidateEventRowData("consolidate_event", { 
      domain_id: alertcaseScreenData.domain_id,
      process_type_id: alertcaseScreenData.process_type_id,
      event: alertedEventData,
      event_type_id: eventId,
      rowData: []
    }, undefined, "none");
  };

  useEffect(() => {
    if (postConsolidateEventRowDataStatus === "completed" && !postConsolidateEventRowDataError) {
      setIsDirty(false);
      setFlag(false);
      next();
    }
  }, [postConsolidateEventRowDataStatus, postConsolidateEventRowDataError]);

  const multitabConfig: IMultiTabComponentConfig = {
    activeTab: "alertCaseSetup",
    tabs: [{
      name: "AlertCase Setup",
      key: "alertCaseSetup",
      content: <AlertCaseSetup
        alertcaseData={alertcaseScreenData}
        onDataChange={(currentData: IAlertCaseSetupData) => {
          setAlertcaseScreenData(currentData);
          setAlertedEventData({});
        }}/>
    }, {
      name: "Create Event",
      key: "createEvent",
      content: <CreateNewEventRow
        eventCaptureId={alertcaseScreenData.event_capture_id}
        eventData={alertedEventData}
        layout={layout}
        onDataChanged={setAlertedEventData}
        onCreateEvent={handleAddNewEvent}
      />,
      isVisible: () => alertcaseScreenData.process_type_id !== ""
    }]
  };

  return (
    <div className="alertcaseNew">
      <div className="spinner-container">         
        {validateLoadingStatusNew([getEventCaptureStatus, postConsolidateEventRowDataStatus]) && <Spinner />}
      </div>
      <div>
        <span>
          <div onClick={() => handleBack()} className="listPage-nav-btn">
            <BsArrowLeft />
          </div>
          <div className="alertcaseNew-header">
            <h1>Create New AlertCase</h1>
          </div>
        </span>
      </div>
      <MultiTabComponent {...multitabConfig}/>
      {flag && <ConfirmationPopup 
        show={flag}
        handleSaveClick={handleAddNewEvent}
        handlePopupClosed={() => {setFlag(false);}}
        handleContinue={() => { next(); setFlag(false); }} />}
    </div>
  );
};

export default AlertCaseNew;